'use client';
import cx from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useApp } from '@/forApp/states/appState/appState';
import { useUser } from '@/forApp/states/userState/userState';
import { Icons } from '@/shared/Icons/Icons';
import styles from './styles.module.css';
import { getRouteHref, ROUTES } from '@/forApp/utils/routes';
import { DEFAULT_SEARCH_TYPE } from '@/forApp/utils/constants';

// const profileTabs = [
// 	{
// 		title: "Личный кабинет",
// 		value: "profile",
// 	},
// 	{
// 		title: "Агенты",
// 		value: "agents",
// 	},
// 	{
// 		title: "Мои объявления",
// 		value: "promotions",
// 	},
// 	{
// 		title: "Избранное",
// 		value: "favorites",
// 	},
// ];
const MobileMenu = () => {
  const router = useRouter();
  const { user } = useUser();
  const { addModal, toggleIsOpenMobileMenu } = useApp();
  const onCloseMenu = () => {
    toggleIsOpenMobileMenu(false);
  };
  const onOpen = () => {
    addModal({ name: 'AuthModal', type: 'login' });
    onCloseMenu();
  };

  const handleClick = (link: string) => {
    router.push(link);
    onCloseMenu();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
        {user ? (
          <>
            <div
              className={cx(styles.item, styles.mainItem)}
              onClick={() => {
                handleClick(
                  getRouteHref(ROUTES.CATALOG, { type: DEFAULT_SEARCH_TYPE }),
                );
              }}
            >
              <Icons.Search width={20} height={20} />
              <span>Новый поиск</span>
            </div>
            <div
              className={cx(styles.item, styles.mainItem)}
              onClick={() => {
                handleClick('/profile/');
              }}
            >
              <Icons.Profile width={20} height={20} />
              <span>Профиль</span>
            </div>
            <div
              className={cx(styles.item, styles.mainItem)}
              onClick={() => {
                handleClick('/profile/favorites/');
              }}
            >
              <Icons.Heart width={20} height={20} />
              <span>Избранное</span>
            </div>
            <div
              className={cx(styles.item, styles.mainItem)}
              onClick={() => {
                handleClick('/profile/promotions/');
              }}
            >
              <Icons.Ads width={20} height={20} />
              <span>Мои объявления</span>
            </div>
          </>
        ) : (
          <>
            <div className={cx(styles.item, styles.mainItem)} onClick={onOpen}>
              <Icons.Pencil width={20} height={20} />
              <span>Войти</span>
            </div>
            <div
              className={cx(styles.item, styles.mainItem)}
              onClick={() => {
                handleClick(
                  getRouteHref(ROUTES.CATALOG, { type: DEFAULT_SEARCH_TYPE }),
                );
              }}
            >
              <Icons.Search width={20} height={20} />
              <span>Новый поиск</span>
            </div>
          </>
        )}
      </div>

      <div className={styles.section}>
        <Link
          href={ROUTES.SERVICES}
          onClick={onCloseMenu}
          className={cx(styles.item, styles.muted)}
        >
          Услуги портала
        </Link>
        <Link
          href={ROUTES.ABOUT}
          onClick={onCloseMenu}
          className={cx(styles.item, styles.muted)}
        >
          О портале
        </Link>
        <Link
          href={ROUTES.FAQ}
          onClick={onCloseMenu}
          className={cx(styles.item, styles.muted)}
        >
          Помощь
        </Link>
      </div>

      <div className={styles.footerSpace}></div>
    </div>
  );
};

export default MobileMenu;
